// Owner in P4: piece 6 "solutions" (docs/FILE-OWNERSHIP.md, "The P4 pieces").
// The feature's entry file (docs/CONTRACTS.md sections 16 and 22.6): `/solutions`, one lazy chunk. Paths carry ids and codes only (section 5).
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Package } from 'lucide-react'
import type { Feature } from '../feature.ts'

export const feature: Feature = {
  app: (parent) => [createRoute({ getParentRoute: () => parent, path: '/solutions', component: lazyRouteComponent(() => import('./SolutionsScreen.tsx')) })],
  nav: [{ to: '/solutions', label: 'nav.solutions', icon: Package, group: 'later', key: 's' }],
}
